import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../icons/Icon';
import moment from 'moment-timezone';

class SessionList extends Component {
  static propTypes = {
    context: PropTypes.oneOf(['user', 'movement-specialist']).isRequired,
    headerTitle: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    onItemView: PropTypes.func.isRequired,
    sessions: PropTypes.array.isRequired,
    showHistoryModal: PropTypes.func,
    type: PropTypes.string.isRequired,
  };

  getSessionIcon = sessionType => {
    let sessionIcon = '';

    switch (sessionType) {
      case 'online':
        sessionIcon = 'Computer';
        break;
      case 'in-person':
        sessionIcon = 'People';
        break;
      case 'movement-specialist':
        sessionIcon = 'Golf';
        break;
      default:
        sessionIcon = 'Tathata-Logo';
    }

    return sessionIcon;
  };

  renderNewSessionRows = () => {
    const { context, sessions, onItemView } = this.props;

    return sessions.map((session, index) => {
      const expireAfterDays = session.type === 'movement-specialist' ? 3 : 5;
      const expirationDate = moment(session.submitted_at)
        .tz(session.time_zone_id)
        .add(expireAfterDays, 'days');
      const displayName =
        session.type === 'movement-specialist'
          ? context === 'user' ? session.movementSpecialist.movementSpecialistProfile.name : session.user.name
          : 'Tathata Golf';

      return (
        <div key={index} className="session-list__item">
          <Icon icon="Arrow" />
          <div className="session-list__item__content" onClick={() => onItemView(session)}>
            <span className="session-list__item-status session-list__item-status--new">
              <span>{`Expire${expirationDate.isAfter() ? 's' : 'd'} ${expirationDate.fromNow()}`}</span>
            </span>
            <div className="session-list__item-status--name-type">
              <Icon icon={this.getSessionIcon(session.type)} />
              {displayName}
            </div>
          </div>
        </div>
      );
    });
  };

  renderBookedSessionRows = () => {
    const { context, sessions, onItemView } = this.props;

    return sessions.map((session, index) => {
      const displayDate = moment(session.accepted_session_date).tz(session.time_zone_id);
      const displayName =
        session.type === 'movement-specialist'
          ? context === 'user' ? session.movementSpecialist.movementSpecialistProfile.name : session.user.name
          : 'Tathata Golf';

      return (
        <div key={index} className="session-list__item">
          <Icon icon="Arrow" />
          <div onClick={() => onItemView(session)} className="session-list__item__content">
            <span className="session-list__item-status">
              {moment()
                .tz(session.time_zone_id)
                .isSame(displayDate, 'day') ? (
                <span>Today {displayDate.format('h:mmA')}</span>
              ) : (
                <span>{displayDate.format('MMM D h:mmA')}</span>
              )}
            </span>
            <div className="session-list__item-status--name-type">
              <Icon icon={this.getSessionIcon(session.type)} />
              {displayName}
            </div>
          </div>
        </div>
      );
    });
  };

  renderCompletedSessionRows = () => {
    const { context, sessions, onItemView } = this.props;

    return sessions.map((session, index) => {
      const displayDate = moment(session.accepted_session_date).tz(session.time_zone_id);
      const displayName =
        session.type === 'movement-specialist'
          ? context === 'user' ? session.movementSpecialist.movementSpecialistProfile.name : session.user.name
          : 'Tathata Golf';

      if (context === 'user' && index > 4) {
        return null;
      }

      return (
        <div key={index} className="session-list__item">
          <Icon icon="Arrow" />
          <div onClick={() => onItemView(session)} className="session-list__item__content">
            <span className="session-list__item-status">
              {moment()
                .tz(session.time_zone_id)
                .isSame(displayDate, 'day') ? (
                <span>Today {displayDate.format('h:mmA')}</span>
              ) : (
                <span>{displayDate.format('MMM D h:mmA')}</span>
              )}
            </span>
            <div className="session-list__item-status--name-type">
              <Icon icon={this.getSessionIcon(session.type)} />
              {displayName}
            </div>
          </div>
        </div>
      );
    });
  };

  render() {
    const { icon, headerTitle, type, sessions, showHistoryModal } = this.props;

    return (
      <div className="session-list">
        <div className="session-list__header">
          <Icon icon={icon} />
          <h3>{headerTitle}</h3>
        </div>
        {sessions.length ? (
          <div>
            {type === 'new' && this.renderNewSessionRows()}
            {type === 'booked' && this.renderBookedSessionRows()}
            {type === 'completed' && (
              <div>
                {this.renderCompletedSessionRows()}
                {sessions.length > 5 && (
                  <span onClick={showHistoryModal} className="show-history">
                    Show History
                  </span>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="session-list__no-sessions">No Follow-Ups</div>
        )}
      </div>
    );
  }
}

export default SessionList;



// WEBPACK FOOTER //
// ./src/common/components/SessionList.js